import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import * as html2canvas from "html2canvas";
import {
  NbWindowService,
  NbWindowState,
  NbDialogService,
} from "@nebular/theme";
import { AlertService } from "../../../../@core/api/alert.service";
import { Alert } from "../../../../@core/data/alert";
import { Router } from "@angular/router";
import { ConfirmDialogComponent } from "../../../utils/confirm-dialog/confirm-dialog.component";

@Component({
  selector: "ngx-alert-row",
  templateUrl: "./alert-row.component.html",
  styleUrls: ["./alert-row.component.scss"],
})
export class AlertRowComponent implements OnInit {
  @Input() alert: Alert;
  @Output() updateList = new EventEmitter();

  constructor(
    private router: Router,
    private dialogService: NbDialogService,
    private alertService: AlertService
  ) {}

  async ngOnInit() {}

  show(type) {
    switch (type) {
      case "edit":
        this.router.navigate(["home", "alert", this.alert.id]);
        break;
      case "copy":
        this.copyAlert();
        break;

      case "delete":
        this.dialogService
          .open(ConfirmDialogComponent, {
            context: { operation: "eliminare " + this.alert.name },
          })
          .onClose.subscribe((res) => {
            if (res) {
              this.DeleteAlert();
            }
          });
        break;
    }
  }

  async copyAlert() {
    let alert = this.alert;
    alert.name = alert.name + " (Copia)";
    let res = <any>await this.alertService.createAlert(alert);
    this.updateList.emit();
  }

  async toggleAlert() {
    let alert = this.alert;

    console.log(alert)
    let res = <any>(
      await this.alertService.editAlert(alert, alert.id)
    );
    this.updateList.emit();
  }

  async DeleteAlert() {
    await this.alertService.deleteAlert(this.alert.id);
    this.updateList.emit();
  }
}
